import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum OrderJoinErrorType {
  ORDER_ASSIGNED_TO_DRIVER = "ORDER_ASSIGNED_TO_DRIVER",
  CHANGE_RIDE_RELATED = "CHANGE_RIDE_RELATED",
}

export enum OrderJoinChangeTargetRideErrorType {
  NODE_ALREADY_CHECKED_OUT = "NODE_ALREADY_CHECKED_OUT",
  RESULT_INCONSISTENT_TIMING = "RESULT_INCONSISTENT_TIMING",
  RESULT_TIMING_NOT_POSSIBLE = "RESULT_TIMING_NOT_POSSIBLE",
  RESULT_CARGO_PROGRESSION_ERROR = "RESULT_CARGO_PROGRESSION_ERROR",
  RESULT_CARGO_PROGRESSION_MISSING_ENTER_SUBJECT = "RESULT_CARGO_PROGRESSION_MISSING_ENTER_SUBJECT",
  NO_VALID_CARGO_TAXI_CONTRACT = "NO_VALID_CARGO_TAXI_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  NO_RELEVANT_DISPATCH_FOUND = "NO_RELEVANT_DISPATCH_FOUND",
  PASSENGERS_DO_OVERLAP = "PASSENGERS_DO_OVERLAP",
  DEFAULT = "DEFAULT",
}

export type OrderJoinAssignedToDriverError = DataLoadError<
  OrderJoinErrorType.ORDER_ASSIGNED_TO_DRIVER,
  {}
>;

export type OrderJoinChangeRideRelatedError = DataLoadError<
  OrderJoinErrorType.CHANGE_RIDE_RELATED,
  {
    changeTargetRideError: {
      errorType: OrderJoinChangeTargetRideErrorType;
    };
  }
>;

type OrderJoinError =
  | DataLoadDefaultErrors
  | OrderJoinAssignedToDriverError
  | OrderJoinChangeRideRelatedError;

export default OrderJoinError;
